import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'd-style-wrapper',
  imports: [],
  template: '<ng-content/>',
  styleUrl: './d-style-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeightonStyleWrapperComponent {}
